import {
  ComplianceEntityForm,
  ComplianceEntityTaxClassification
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Maps a v1 `CompanyStructure` (from `FormPartialCompanyStructure`) to the v3
 * compliance-entity `form` + `taxClassification` pair. Kept 1:1 with the
 * contractor-onboarding create flow (`Onboarding/steps/CreateAccount/
 * useMutationSubmit.ts`) so the payer-supplied W-9 and the contractor's own
 * onboarding classify identically. Unknown/absent structures yield `{}`.
 */
export const selectorComplianceEntityFormAndClassification = (
  companyStructure?: string
): {
  form?: ComplianceEntityForm;
  taxClassification?: ComplianceEntityTaxClassification;
} => {
  switch (companyStructure) {
    case "SoleProprietorship":
      return { form: ComplianceEntityForm.SOLE_PROPRIETORSHIP };
    case "LlcSingleMember":
      return {
        form: ComplianceEntityForm.LIMITED_LIABILITY,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_DISREGARDED_ENTITY
      };
    case "CorporationS":
      return {
        form: ComplianceEntityForm.CORPORATION,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_S_CORPORATION
      };
    case "CorporationC":
      return {
        form: ComplianceEntityForm.CORPORATION,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_C_CORPORATION
      };
    case "Partnership":
      return {
        form: ComplianceEntityForm.PARTNERSHIP,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_PARTNERSHIP
      };
    case "LlcCorporationS":
      return {
        form: ComplianceEntityForm.LIMITED_LIABILITY,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_S_CORPORATION
      };
    case "LlcCorporationC":
      return {
        form: ComplianceEntityForm.LIMITED_LIABILITY,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_C_CORPORATION
      };
    case "LlcPartnership":
      return {
        form: ComplianceEntityForm.LIMITED_LIABILITY,
        taxClassification:
          ComplianceEntityTaxClassification.TAXED_AS_PARTNERSHIP
      };
    case "NotForProfitOrganization":
      return { form: ComplianceEntityForm.NON_PROFIT };
    default:
      return {};
  }
};
